import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const UserPrivateRoute = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  return user ? <Outlet /> : <Navigate to={"/auth/login"} />;
};

export default UserPrivateRoute;
